module.exports = __webpack_public_path__ + "img/credit-card-bg-circle.187e2386.svg";